var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-page-container"},[(!_vm.page.loading)?_c('VideoPlayer',{attrs:{"url":_vm.page.video && _vm.page.video.videoUrl},on:{"timeupdate":_vm.handleTimeUpdate,"pause":_vm.handlePause,"ended":_vm.handleEnded}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }